// src/constants/fourGodsConfig.js

/**
 * 四神獣キャラクターランディングページ用設定
 * （2026.10.1 新宿イベント連動企画）
 *
 * 【運用ルール】
 * - pushPageUrl は現時点ではTBD（仮URL）。確定次第ここを更新する。
 * - keyword は完全一致判定（大文字小文字・全半角などのバリデーションは行わない）。
 */
export const FOUR_GODS_CONFIG = {
  genbu: {
    id: 'genbu',
    text: 'ゲンブに出会うためのひみつのことばを入力しよう！',
    keyword: 'ミンナデダンス',
  pushPageUrl: 'https://nft.rural.ne.jp/#/card-details/2389/2655',
    errorMessage: 'ひみつのことばが違うよ',
    backgroundImage: '/images/other/2026.10.1/backgrounds/genbu.svg',
    characterImage: '/images/other/2026.10.1/characters/genbu.svg',
  },
  byakko: {
    id: 'byakko',
    text: 'ビャッコに出会うためのひみつのことばを入力しよう！',
    keyword: 'ヤセイノチカラ',
  pushPageUrl: 'https://nft.rural.ne.jp/#/card-details/2389/2656',
    errorMessage: 'ひみつのことばが違うよ',
    backgroundImage: '/images/other/2026.10.1/backgrounds/byakko.svg',
    characterImage: '/images/other/2026.10.1/characters/byakko.svg',
  },
  suzaku: {
    id: 'suzaku',
    text: 'スザクに出会うためのひみつのことばを入力しよう！',
    keyword: 'ソラヘノハバタキ',
  pushPageUrl: 'https://nft.rural.ne.jp/#/card-details/2389/2657',
    errorMessage: 'ひみつのことばが違うよ',
    backgroundImage: '/images/other/2026.10.1/backgrounds/suzaku.svg',
    characterImage: '/images/other/2026.10.1/characters/suzaku.svg',
  },
  seiryu: {
    id: 'seiryu',
    text: 'セイリュウに出会うためのひみつのことばを入力しよう！',
    keyword: 'ミズベデオヒルネ',
  pushPageUrl: 'https://nft.rural.ne.jp/#/card-details/2389/2658',
    errorMessage: 'ひみつのことばが違うよ',
    backgroundImage: '/images/other/2026.10.1/backgrounds/seiryu.svg',
    characterImage: '/images/other/2026.10.1/characters/seiryu.svg',
  },
};

/**
 * 5ページ目（5kirin5：4問まとめページ）用設定
 * 4神獣の問題を1ページに集約し、4問すべて正解した場合のみ遷移する。
 */
export const FIVE_KIRIN_CONFIG = {
  id: '5kirin5',
  questions: [
    {
      characterId: 'genbu',
      text: 'ゲンブに出会うためのひみつのことばを入力しよう！',
      keyword: 'ミンナデダンス',
      characterImage: '/images/other/2026.10.1/characters/genbu.svg',
    },
    {
      characterId: 'byakko',
      text: 'ビャッコに出会うためのひみつのことばを入力しよう！',
      keyword: 'ヤセイノチカラ',
      characterImage: '/images/other/2026.10.1/characters/byakko.svg',
    },
    {
      characterId: 'suzaku',
      text: 'スザクに出会うためのひみつのことばを入力しよう！',
      keyword: 'ソラヘノハバタキ',
      characterImage: '/images/other/2026.10.1/characters/suzaku.svg',
    },
    {
      characterId: 'seiryu',
      text: 'セイリュウに出会うためのひみつのことばを入力しよう！',
      keyword: 'ミズベデオヒルネ',
      characterImage: '/images/other/2026.10.1/characters/seiryu.svg',
    },
  ],
  pushPageUrl: 'https://nft.rural.ne.jp/#/card-details/2389/2659',
  errorMessage: 'ひみつのことばが違うよ',
  backgroundImage: '/images/other/2026.10.1/backgrounds/5kirin5.svg',
};

// 共通素材（全ページ共通）
export const FOUR_GODS_SHARED_IMAGES = {
  title: '/images/other/2026.10.1/shared/title.png',
  logo: '/images/other/2026.10.1/shared/logo.png',
};
